"use client";
import * as React from "react";
const SvgSpinnerOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 15 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8 2a6 6 0 1 0 0 12v2a8 8 0 1 1 6.93-12L13.2 5A6 6 0 0 0 8 2", clipRule: "evenodd" }));
export {
  SvgSpinnerOutlined as default
};
